import React, { useCallback } from "react";
import { api, appendQueryParams } from "../../util/api";
import { RemotePaginateSelector } from "./RemotePaginateSelector";
import { useDebounced } from "../../util/hooks";

export const PAYOR_URL = "/payors.json";

export const PayorSelector = ({
  resourceUrl = PAYOR_URL,
  scope,
  valueSelector = "id",
  labelSelector = "name",
  usOnly = false,
  queryParams = {},
  ...rest
}) => {
  const loadDefaultOptions = useDebounced(
    useCallback(async () => {
      try {
        const res = await api.get(`/payors/find_by_ids`, { params: { id: rest.value } });
        return res.data.resources.map((p) => ({ value: p[valueSelector], label: p[labelSelector] }));
      } catch (error) {
        console.error("Failed to fetch default options for payor selector:", error);
        return [];
      }
    }, [rest.value, labelSelector, valueSelector]),
    300,
    false
  );

  return (
    <>
      <RemotePaginateSelector
        {...rest}
        valueKey={valueSelector}
        labelKey={labelSelector}
        scope={scope}
        loadDefaultOptions={rest.value ? loadDefaultOptions : undefined}
        resourceUrl={appendQueryParams(resourceUrl ?? "", queryParams)}
        extraParams={{ usOnly: usOnly }}
        dataKey="resources"
      />
    </>
  );
};
